module.exports = __webpack_public_path__ + "img/favicon.c1409293.png";